// fragno-support.js
// Behavioral support for fragno web components in idme-idp.
// Add future fragno-related JS support here.

// Navigation bridge: fragno-button is a pure button with no built-in navigation
// support. Buttons with a data-href attribute navigate on click.
// The loading attribute is set before navigation to prevent double-clicks.
// TODO(AXP-827): propose a native href/action attribute for fragno-button
// so this bridge is no longer needed.
document.addEventListener('fragno-button-click', (event) => {
  const href = event.target.getAttribute('data-href');
  if (!href) return;
  event.target.setAttribute('loading', 'true');
  window.location.href = href;
});
